import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { $Tooltip } from "us.common/components";
import { getAdditionalReferenceStatusColor } from "us.common/functions";

interface Props {
  arId: number;
  creditorName: string;
  debtorName: string;
  additionalReference1: string;
  additionalReference2: string;
  additionalReference3: string;
}

const ParentRow: React.FC<Props> = ({ arId, creditorName, debtorName, additionalReference1, additionalReference2, additionalReference3}) => {
  const { t } = useTranslation();
  const referenceColor = useMemo(() => {
    return getAdditionalReferenceStatusColor(additionalReference3);
  }, [additionalReference3]);
  return (
    <div
      className="d-flex flex-wrap"
      style={{ fontSize: "0.75rem" }}
      key={arId}
      data-testid="parent-row"
    >
      <span className="mr-4 text-nowrap d-flex">
        {`${t("US.COLLECTION.ECONOMY:MANAGE_PAYMENTS.AR")}:`}
        <span className="font-weight-bold ml-2">{arId}</span>
      </span>
      <span className="mr-4 text-nowrap d-flex">
        {`${t("US.COLLECTION.ECONOMY:MANAGE_PAYMENTS.CREDITOR")}:`}
        <span className="font-weight-bold ml-2">{creditorName}</span>
      </span>
      <span className="mr-4 text-nowrap d-flex">
        {`${t("US.COLLECTION.ECONOMY:MANAGE_PAYMENTS.DEBTOR")}:`}
        <span className="font-weight-bold ml-2">{debtorName}</span>
      </span>
      {(additionalReference1 || additionalReference2) && (
        <>
          <span className="mr-4 text-nowrap d-flex">
            {`${t("US.COLLECTION.COMMON:COMMON.ADDITIONAL_REFERENCE_1_ID")}:`}
            <span
              className=" ml-2 d-inline-block font-weight-bold"
              style={{ color: referenceColor }}
            >
              {additionalReference1}
            </span>{" "}
          </span>
        </>
      )}
      {(additionalReference1 || additionalReference2) && (
        <>
          <span className="mr-4 text-nowrap d-flex">
            {`${t("US.COLLECTION.COMMON:COMMON.ADDITIONAL_REFERENCE_2_ID")}:`}
            <span
              className="ml-2 d-inline-block font-weight-bold"
              style={{ color: referenceColor }}
            >
              {additionalReference2}
            </span>{" "}
          </span>
        </>
      )}
    </div>
  );
};

export default ParentRow;
